import { rankings } from "@/mocks/mangaData";

const medal = ["bg-accent-500", "bg-foreground-400", "bg-primary-700"];

export default function Rankings() {
  return (
    <section id="rank" className="py-12 md:py-20 bg-foreground-950">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-12">
          <div>
            <span className="inline-flex items-center gap-1.5 text-accent-400 text-sm font-medium">
              <i className="ri-trophy-fill"></i>
              一生推榜单
            </span>
            <h2 className="mt-2 font-display text-2xl md:text-4xl text-background-50">
              本命漫人气 Top 8
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-300 max-w-xl">
              由千万读者口碑与编辑团队综合评选，每一部都是值得一生推的入坑作。
            </p>
          </div>
          <a
            href="#recommend"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg border border-background-50/20 text-background-50 text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {rankings.map((r) => (
            <a
              key={r.id}
              href="#recommend"
              className="flex items-center gap-4 p-3 md:p-4 rounded-xl bg-background-50/5 border border-background-50/10 hover:bg-background-50/10 transition-colors"
            >
              <span
                className={`w-9 h-9 md:w-10 md:h-10 shrink-0 rounded-lg flex items-center justify-center font-display text-lg text-foreground-950 ${
                  r.rank <= 3 ? medal[r.rank - 1] : "bg-background-50/10 text-background-50"
                }`}
              >
                {r.rank}
              </span>
              <div className="w-12 md:w-14 shrink-0 rounded-md overflow-hidden aspect-[3/4] bg-background-50/10">
                <img
                  src={r.cover}
                  alt={`${r.title}本命漫排行封面`}
                  title={`${r.title} - 131漫画网一生推榜单`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-display text-base md:text-lg text-background-50 truncate">
                  {r.title}
                </h3>
                <p className="mt-0.5 text-xs md:text-sm text-foreground-300">{r.genre}</p>
              </div>
              <div className="text-right shrink-0">
                <span className="font-display text-lg md:text-xl text-accent-400">{r.score}</span>
                <p className="text-[10px] text-foreground-400 whitespace-nowrap">本命评分</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}